import { Component, OnInit } from '@angular/core';
import {JobService} from '../../shared/services/job.service';
import {group_by_item_count} from '../../functions';
import {TestimonialService} from '../../shared/services/testimonial.service';
import {AuthenticationService} from '../../shared/services/authentication.service';
import {CompanyService} from '../../shared/services/company.service';
import {TranslateService} from '@ngx-translate/core';
import {EventService} from '../../shared/services/event.service';
import {VideoService} from '../../shared/services/video.service';
import {ExternalpageService} from '../../shared/services/externalpage.service';
import {empty} from '../../functions';
import {LocaleService} from "../../shared/services/locale.service";

@Component({
    selector: 'app-page-i-am-a-student',
    templateUrl: './page-i-am-a-student.component.html',
    styleUrls: ['./page-i-am-a-student.component.scss'],
    standalone: false
})
export class PageIAmAStudentComponent implements OnInit {

  empty = empty;

  jobs: any = [];
  companies: any = [];

  public jobSlider = {
    slides_desktop: [],
    slides_mobile: []
  };

  public companySlider = {
    slides_desktop: [],
    slides_mobile: []
  }

  testimonialSlider = {
    slides :<any> []
  };

  eventSlider = {
    slides_desktop: <any> [],
    slides_mobile: <any> []
  };

  events: any[] = [];


  /**
   * Constructor
   *
   * @param jobService
   * @param testimonialService
   * @param authService
   * @param companyService
   * @param videoService
   * @param eventService
   * @param translate
   * @param externalpageService
   */
  constructor(public jobService: JobService,
              public testimonialService: TestimonialService,
              public authService: AuthenticationService,
              public companyService: CompanyService,
              public videoService: VideoService,
              public eventService: EventService,
              public translate: TranslateService,
              public externalpageService: ExternalpageService,
              public locale: LocaleService
  ) {

    this.eventService.setHomeData();
    this.testimonialService.setHomeData();
    this.companyService.setHomeData();
    this.jobService.setHomeData();

    // Load home events data
    this.events = this.eventService.homeData;
    if (this.events.length == 0) {
      this.eventService.$homeDataSubject.subscribe( (value) => {
        this.events = this.eventService.homeData;
        this.eventSlider.slides_desktop = group_by_item_count(this.events, 3);
        this.eventSlider.slides_mobile =  group_by_item_count(this.events, 1);
      });
    } else {
      this.eventSlider.slides_desktop = group_by_item_count(this.events, 3);
      this.eventSlider.slides_mobile =  group_by_item_count(this.events, 1);
    }

    this.eventSlider.slides_desktop = group_by_item_count(this.events, 3);
    this.eventSlider.slides_mobile =  group_by_item_count(this.events, 1);

    // Load home company data
    this.companies = this.companyService.homeData;
    if (this.companies.length == 0) {
      this.companyService.$homeDataSubject.subscribe( (value) => {
        this.companies = this.companyService.homeData;
        this.companySlider.slides_desktop = group_by_item_count(this.companies, 10);
        this.companySlider.slides_mobile =  group_by_item_count(this.companies, 2);
      });
    } else {
      this.companySlider.slides_desktop = group_by_item_count(this.companies, 10);
      this.companySlider.slides_mobile =  group_by_item_count(this.companies, 2);
    }

    // Load home job posting data
    this.jobs = this.jobService.homeData;
    if (this.jobs.length == 0) {
      this.jobService.$homeDataSubject.subscribe( (value) => {
        this.jobs = this.jobService.homeData;
        this.jobSlider.slides_desktop = group_by_item_count(this.jobs, 4);
        this.jobSlider.slides_mobile =  group_by_item_count(this.jobs, 1);
      });
    } else {
      this.jobSlider.slides_desktop = group_by_item_count(this.jobs, 4);
      this.jobSlider.slides_mobile =  group_by_item_count(this.jobs, 1);
    }

    // Load home testimonial data
    this.testimonialSlider.slides = this.testimonialService.homeData;
    if (this.testimonialSlider.slides.length == 0) {
      this.testimonialService.$homeDataSubject.subscribe( (value) => {
        this.testimonialSlider.slides = this.testimonialService.homeData;
      });
    } else {
      this.testimonialSlider.slides = this.testimonialService.homeData;
    }

  }

  /**
   * Ng on init
   */
  ngOnInit(): void {


  }

  Register()
  {

    this.authService.Login();

  }

}
